var map = {
	"./common.js": "FS6E",
	"./complex.js": "Gxic"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xoy7";


//////////////////
// WEBPACK FOOTER
// ./src/api/api \.js$
// module id = xoy7
// module chunks = 34